/* Claude 3.75 — collapse the express-pay row when no wallet renders.

   Shopify's <shopify-accelerated-checkout> decides per buyer whether there is
   a wallet to show. When there is none the host collapses to nothing, and a
   50/50 row would paint a black half and an empty white half — a hole, on
   every page load, for that visitor.

   OPTIMISTIC BY DEFAULT, and deliberately so. The row starts split. Shop Pay
   is browser-independent and this store has it enabled, so a wallet renders
   for very nearly everyone; collapsing first and expanding on arrival would
   make the common case flash. We only collapse if the slot is still empty
   after the element has had time to load — a rare visitor sees one late
   reflow, everyone else sees nothing move.

   The element hides its markup in a CLOSED shadow DOM, so there is nothing to
   query inside it. Measuring the host box is the only signal available. */
(function () {
  if (window.__claudeExpressPayInit) return;
  window.__claudeExpressPayInit = true;

  var EMPTY = 'claude-express-row--empty';
  /* Below this the box is a collapsed remnant rather than a button. The
     smallest height Shopify will render is 25px; the skeleton fills all 48. */
  var MIN = 16;

  /* MEASURE THE INNER ELEMENT, NOT .shopify-payment-button.

     Caught by a browser test, and it would have shipped silently otherwise:
     .shopify-payment-button is a flex CHILD at 1 1 50%, so the row gives it
     half the width and full height whether or not Shopify put anything inside
     it. Measuring it always reports live and the row never collapses — a black
     half beside an empty white half, exactly the hole this file exists to
     prevent. Only <shopify-accelerated-checkout> collapses when there is no
     wallet, so that is what has to be measured. */
  function slotIsLive(slot) {
    if (!slot) return false;
    var kids = slot.children;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.height >= MIN && r.width >= MIN) return true;
    }
    return false;
  }

  function settle(row) {
    var slot = row.querySelector('.shopify-payment-button');
    /* No container at all is a different thing from an empty one: nothing to
       lay out either way, so collapse. */
    row.classList.toggle(EMPTY, !slotIsLive(slot));
  }

  function watch(row) {
    if (row.__cxpWatched) return;
    row.__cxpWatched = true;

    /* Two checks, then stop. The element registers on its own script's load;
       1.2s covers a warm cache and 3s a cold one on a phone. Past that, an
       absent wallet is absent. */
    setTimeout(function () {
      settle(row);
    }, 1200);
    setTimeout(function () {
      settle(row);
    }, 3000);

    /* If it arrives later than that, or the shopper switches variant and the
       section re-renders, react to the size change rather than poll. */
    if (window.ResizeObserver) {
      var slot = row.querySelector('.shopify-payment-button');
      if (slot) new ResizeObserver(function () { settle(row); }).observe(slot);
    }
  }

  function scan() {
    document.querySelectorAll('.claude-express-row').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* product-info re-renders the buy buttons on every variant change, which
     replaces the row node and its listeners. */
  if (window.MutationObserver) {
    new MutationObserver(scan).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();